import {
  type AuthMeResponse,
  WorkspaceMembershipRole,
  type WorkspaceAccessRole,
} from "@/features/auth/model/auth-types"

// The workspace authority is the OWNER (the ADMIN/USER workspace roles were collapsed into the Owner/Member model;
// branch-level authority is expressed by assigned roles, not the workspace membership role).
const AUTHORITY_ROLES: WorkspaceAccessRole[] = [WorkspaceMembershipRole.Owner]

export function isWorkspaceOwnerOrAdminRole(role: WorkspaceAccessRole | undefined): boolean {
  return role !== undefined && AUTHORITY_ROLES.includes(role)
}

/**
 * Member registration form configuration is limited to workspace OWNER/ADMIN
 * (matches backend `requireWorkspaceOwnerOrAdmin`).
 */
export function canManageWorkspaceMemberRegistrationForms(
  authMe: AuthMeResponse | null,
  workspaceId: string | null,
): boolean {
  if (!authMe?.workspaceAccess || !workspaceId) return false
  const entry = authMe.workspaceAccess.find(
    (w) => w.status === "ACTIVE" && w.workspace.id === workspaceId,
  )
  return isWorkspaceOwnerOrAdminRole(entry?.workspaceRole)
}
